import { AccordionPanel, Box } from 'grommet';
import styled from 'styled-components';

export const StyledPanel = styled(AccordionPanel)`
  border-radius: 20px;
  box-shadow: 0 2px 10px rgb(0 0 0 / 25%);
  overflow: hidden;
  width: 100%;
  margin-top: 1rem;
  padding: 1rem;
`;

export const StyledChildBox = styled(Box)`
  border-radius: 20px;
  box-shadow: 0 2px 10px rgb(0 0 0 / 25%);
  overflow: hidden;
  width: 100%;
  margin-top: 0.5rem;
  color: #333333;
`;
